import React from "react";
import { Tooltip, Typography } from "antd";
import { InfoCircleOutlined } from "@ant-design/icons";

const { Paragraph, Text } = Typography;

const AgencyPreferenceTip = () => {
  const content = (
    <div>
      <div>
        Choose which agencies will be pre-selected when you
        <Text underline style={{ color: "white" }}> Search Documents. </Text>
      </div>

      <Paragraph />

      <div>
        If you search across many agencies often, select them here to avoid re-selecting them each time.
      </div>

      <Paragraph />
    </div>
  );

  return (
    <Tooltip title={content} placement="right">
      <InfoCircleOutlined style={{ color: "#1890ff", cursor: "pointer" }} />
    </Tooltip>
  );
};

export default AgencyPreferenceTip;
